const e = { aria_label: "Cerca", clear: "Cancella", placeholder_article: "", placeholder_header: "Cerca un articolo" }, a = {
  searcher: e
};
export {
  a as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search39.js.map
